/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CropReport } from '../../models/crop-report';

export interface GetCropReportByReportId$Params {
  cropReportId: string;
}

export function getCropReportByReportId(http: HttpClient, rootUrl: string, params: GetCropReportByReportId$Params, context?: HttpContext): Observable<StrictHttpResponse<CropReport>> {
  const rb = new RequestBuilder(rootUrl, getCropReportByReportId.PATH, 'get');
  if (params) {
    rb.path('cropReportId', params.cropReportId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CropReport>;
    })
  );
}

getCropReportByReportId.PATH = '/api/cropreport/{cropReportId}';
